/**
 * Infrastructure Type Helpers
 *
 * Provides type set utilities for virtual infrastructure subtypes.
 * Used to determine which subtype categories are selected for batch operations.
 */

import {
    HYPERVISOR_TYPE,
    VCENTER_TYPE,
    VIRTUALMACHINE_TYPE,
} from '../../filters/virtual-infrastructure-type-filter/SubTypeHelper';

const VCENTER_TYPE_SET = new Set([VCENTER_TYPE]);
const HYPERVISOR_TYPE_SET = new Set([HYPERVISOR_TYPE]);
const VIRTUALMACHINE_TYPE_SET = new Set([VIRTUALMACHINE_TYPE]);

/**
 * Returns a Set containing the specified subtype.
 * Used to filter infrastructure items by their subtype category.
 *
 * @param {string} subType - The infrastructure subtype (VCENTER_TYPE, HYPERVISOR_TYPE, or VIRTUALMACHINE_TYPE)
 * @returns {Set<string>} A Set containing the subtype
 */
export const getSubtypeSet = (subType) => {
    switch (subType) {
        case VCENTER_TYPE:
            return VCENTER_TYPE_SET;
        case HYPERVISOR_TYPE:
            return HYPERVISOR_TYPE_SET;
        default:
            return VIRTUALMACHINE_TYPE_SET;
    }
};
